import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnlineexamRoutingModule } from './onlineexam-routing.module';
import { OnlineexamListComponent } from './onlineexam-list/onlineexam-list.component';
import { OnlineexamCreateComponent } from './onlineexam-create/onlineexam-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [OnlineexamListComponent, OnlineexamCreateComponent],
  imports: [
    CommonModule,
    OnlineexamRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class OnlineexamModule { }
